var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptedIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8918 8.20924L9.24391 14.8571L7.21938 12.8326C6.94042 12.5537 6.48819 12.5537 6.20923 12.8326C5.93026 13.1116 5.93026 13.5638 6.20923 13.8428L8.73883 16.3724C8.87827 16.5119 9.06105 16.5816 9.24391 16.5816C9.42669 16.5816 9.60954 16.5119 9.74899 16.3724L16.902 9.21932C17.181 8.94035 17.181 8.48813 16.902 8.20916C16.6231 7.93027 16.1707 7.93027 15.8918 8.20924Z",
    fill: "#157FFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48595 2 2 6.48595 2 12C2 17.514 6.48595 22 12 22C17.514 22 22 17.514 22 12C22 6.48595 17.514 2 12 2ZM12 20.5714C7.27373 20.5714 3.42857 16.7263 3.42857 12C3.42857 7.27373 7.27373 3.42857 12 3.42857C16.7263 3.42857 20.5714 7.27373 20.5714 12C20.5714 16.7263 16.7263 20.5714 12 20.5714Z",
    fill: "#157FFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedIconBlue);
export default __webpack_public_path__ + "static/media/accepted_icon_blue.909232826cc2e212e5fe14159694392d.svg";
export { ForwardRef as ReactComponent };